import { DefaultHomeComponent } from "./components/home/templates/default/default-home.component";
import { SocialHomeComponent } from "./components/home/templates/social/social-home.component";

export const homeComponentDef = {
    "home": {
        "social": SocialHomeComponent,
        "default": DefaultHomeComponent
    }
}